import { types } from '../../../types/types';

export const pesquisaTratamentoReducer = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.CREDENCIAMENTO.TRATAMENTO_PESQUISA:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}